import { AbstractPeerAccountKeyring, AbstractSelfAccountKeyring } from '../../keyring/account_base';
import { AbstractConfigDumpArgs, AbstractConfigLoadArgs } from '../base';

export class SharedSecretConfigLoadArgs extends AbstractConfigLoadArgs {
  public self_kr;
  public peer_kr;
  public ss_version;

  constructor(
    cipher: Uint8Array,
    self_kr: AbstractSelfAccountKeyring,
    peer_kr: AbstractPeerAccountKeyring,
    ss_version: string
  ) {
    super(cipher);
    this.self_kr = self_kr;
    this.peer_kr = peer_kr;
    this.ss_version = ss_version;
  }
}

export class SharedSecretConfigDumpArgs extends AbstractConfigDumpArgs {
  public shared_secret;
  public self_kr;
  public peer_kr;
  public ss_version;

  constructor(
    shared_secret: Uint8Array,
    self_kr: AbstractSelfAccountKeyring,
    peer_kr: AbstractPeerAccountKeyring,
    ss_version: string
  ) {
    super();
    this.shared_secret = shared_secret;
    this.self_kr = self_kr;
    this.peer_kr = peer_kr;
    this.ss_version = ss_version; // of the SS that would be loaded into the peer_kr (not that created the KEM/SS)
  }
}
